import Vue from 'vue';
import VueSsrCarousel from 'vue-ssr-carousel';

require('vue-ssr-carousel/index.css')

Vue.use(VueSsrCarousel);